<i18n lang="yaml" locale="en">
  none: None
  slide: Slide
  modal: Modal
</i18n>

<i18n lang="yaml" locale="de">
  none: Keiner
  slide: Seite
  modal: Modal
</i18n>

<template>
  <select
    @change="$emit('input', $event.target.value)"
  >
    <option
      value=""
      :selected="value === ''"
    >
      {{ $t('none') }}
    </option>
    <optgroup
      v-for="(group, groupName) in $root.$store.state.links"
      :label="$t(groupName)"
      :key="groupName"
    >
      <option
        v-for="(title, href) in group"
        :key="href"
        :value="href"
        :selected="value === href"
      >
        {{ title }}
      </option>
    </optgroup>
  </select>
</template>

<script>
export default {
  name: 'Link',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

select {
  width: 100%;
  margin-bottom: 1.5rem;
  height: 40px;
  border: 1px solid rgba($color: #fff, $alpha: 0.2);
  background: darken($color-main-darker, 2);
  color: #fff;
  border-radius: 5px;
  font-size: 16px;
  letter-spacing: 0.5pt;
}
</style>
